/**
 * Merge Tool API Module (ISS-04-139)
 */

import { ApiBase, HttpMethod } from "../../core/api-base";

type UnknownRecord = Record<string, unknown>;

export type MergeEntity = "brands" | "products";

export interface MergeCandidatesData {
    source?: UnknownRecord | null;
    candidates?: UnknownRecord[];
}

class MergeToolApi extends ApiBase {
    public static requestMergeCandidates(entity: MergeEntity, id: number, manualTargetId?: number): Promise<Response> {
        const query = manualTargetId && manualTargetId > 0 ? `?target_id=${manualTargetId}` : "";
        return super.apiRequest(`/api/v1/${entity}/${id}/merge-candidates${query}`, HttpMethod.Get);
    }

    public static requestMerge(
        entity: MergeEntity,
        sourceId: number,
        targetId: number,
        fields: UnknownRecord,
    ): Promise<Response> {
        return super.apiRequest(`/api/v1/${entity}/${sourceId}/merge`, HttpMethod.Post, {
            target_id: targetId,
            fields,
        });
    }
}

async function fetchMergeCandidates(
    entity: MergeEntity,
    id: number,
    manualTargetId?: number,
): Promise<MergeCandidatesData | null> {
    const response = await MergeToolApi.requestMergeCandidates(entity, id, manualTargetId);
    if (!response.ok) return null;

    const json = (await response.json().catch(() => null)) as { data?: MergeCandidatesData } | null;
    return json?.data ?? null;
}

async function submitMerge(
    entity: MergeEntity,
    sourceId: number,
    targetId: number,
    fields: UnknownRecord,
): Promise<{ ok: boolean; message?: string }> {
    const response = await MergeToolApi.requestMerge(entity, sourceId, targetId, fields);

    if (!response.ok) {
        const body = (await response.json().catch(() => ({}))) as { message?: string };
        return { ok: false, message: body.message };
    }

    return { ok: true };
}

export { fetchMergeCandidates, submitMerge };
